import React from "react";
import { Autocomplete } from "@react-google-maps/api";
import { Field } from 'redux-form';
import { TextField } from "@material-ui/core";
import { required as requiredValidation } from 'tools/forms/validators';
import styles from './searchInput.module.scss'

const AutocompleteInputField = ({ input, meta, label, inputClassName, style, handleAddressChange, ...rest }) => {
  return (
    <Autocomplete
      restrictions={{ country: "us" }}
      onLoad={(autocomplete) => {
        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          if (!place.address_components) return;
          const addressComponents = place.address_components;
          const address1Component = addressComponents.find((component) =>
            component.types.includes("street_number")
          );
          const routeComponent = addressComponents.find((component) =>
            component.types.includes("route")
          );
          const address2Component = addressComponents.find((component) =>
            component.types.includes("subpremise")
          );
          const cityComponent = addressComponents.find((component) =>
            component.types.includes("locality")
          );
          const stateComponent = addressComponents.find((component) =>
            component.types.includes("administrative_area_level_1")
          );
          const zipCodeComponent = addressComponents.find((component) =>
            component.types.includes("postal_code")
          );
          const countryCodeComponent = addressComponents.find((component) =>
            component.types.includes("country")
          );
          let country = countryCodeComponent?.short_name || "";
          if (country === "US") country = "USA";
          else if (country === "CA") country = "CAN";
          else if (country === "MX") country = "MEX";
          const address1 = `${address1Component?.long_name || ""} ${routeComponent?.long_name || ""}`;
          const address2 = address2Component?.long_name || "";
          const city = cityComponent?.long_name || "";
          const state = stateComponent?.short_name || "";
          const zipCode = zipCodeComponent?.long_name || "";
          // const formattedAddress = `${address1 || ""} ${address2 || ""} ${city || ""} ${state || ""} ${zipCode || ""} ${country || ""}`.trim();
          input.onChange(place.formatted_address);
          // formatted_address
          if (handleAddressChange) {
            handleAddressChange({
              address1,
              address2,
              city,
              state,
              zipCode,
              country
            });
          }
        });
      }}
    >
      <TextField
        {...input}
        {...rest}
        label={label}
        style={style}
        error={meta.touched && meta.error}
        value={input.value}
        onBlur={() => handleAddressChange()}
        variant="outlined"
        size="small"
        className={`${inputClassName} ${styles.formInput} ${styles.withSuffixAdornment
          }`}
      />
    </Autocomplete>
  );
};

const SearchMyAdressComponent = (props) => {
  const {
    name = "businessAddress1",
    label,
    inputClassName,
    style,
    required = false,
    ...rest
  } = props;

  return (
    <Field
      name={name}
      component={AutocompleteInputField}
      label={label}
      inputClassName={inputClassName}
      style={style}
      validate={required ? [requiredValidation] : undefined}
      {...rest}
    />
  );
};

export default SearchMyAdressComponent;
